<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <!-- Dialog export / import -->
          <v-col cols="12">
            <v-btn
              color="primary"
              depressed
              @click="(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              Add
            </v-btn>
            <!-- <v-btn
              color="primary"
              depressed
              @click="(dialogAddVDO = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              Add VDO
            </v-btn> -->
          </v-col>

          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="90%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มข่าว</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="4">
                      <v-card class="mx-auto my-12" max-width="374">
                        <template slot="progress">
                          <v-progress-linear
                            color="deep-purple"
                            height="10"
                            indeterminate
                          ></v-progress-linear>
                        </template>

                        <v-sheet
                          class="rounded-xl rounded-t-0 mx-auto"
                          max-width="100%"
                        >
                          <v-img
                            :src="require('@/assets/news_report.png')"
                          ></v-img>
                        </v-sheet>

                        <v-card-title>ตัวอย่างข่าว</v-card-title>

                        <v-card class="pa-2 mb-7" elevation="10">
                          <v-row>
                            <v-col cols="3" class="pt-5 pl-5">
                              <v-avatar color="grey" size="100" rounded>
                                <v-img :src="formAdd.newsConfigFile"></v-img>
                              </v-avatar>
                            </v-col>
                            <!-- <v-spacer></v-spacer> -->
                            <v-col cols="8" class="pt-2 pl-7 text-right">
                              <v-card-text class="text-left">
                                <h5
                                  class="
                                    indigo--text
                                    d-inline-block
                                    text-truncate
                                  "
                                  style="max-width: 200px"
                                >
                                  {{ formAdd.newsConfigTopic }}
                                </h5>
                                <br />
                                <h6
                                  class="d-inline-block text-truncate"
                                  style="max-width: 200px"
                                >
                                  {{ formAdd.newsConfigHead }}
                                </h6>
                                <v-row
                                  ><caption
                                    color="grey"
                                    class="pl-3 pt-0 pb-0 pr-0 ma-0"
                                  >
                                    {{
                                      formAdd.newConfigStarttime
                                    }}
                                  </caption>
                                  <v-btn color="info" text>
                                    อ่านข่าวเพิ่มเติม
                                  </v-btn>
                                </v-row>
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-divider class="mx-4"></v-divider>

                        <v-card-title>ตัวอย่าง อ่านข่าวเพิ่มเติม</v-card-title>

                        <v-card class="overflow-y-auto" max-height="400">
                          <v-row justify="space-around">
                            <v-col cols="12">
                              <br />

                              <center>
                                <h5 class="purple--text pa-2">
                                  {{ formAdd.newsConfigTopic }}
                                </h5>
                              </center>
                              <!-- รูปปกข่าว -->
                              <v-col>
                                <v-img :src="formAdd.newsConfigFile"></v-img>
                              </v-col>
                              <!-- รูปเพิ่ม1 -->
                              <v-col>
                                <v-img :src="formAdd.newsConfigFileImg"></v-img>
                              </v-col>

                              <v-card-text class="text--primary">
                                <h5 class="indigo--text">
                                  {{ formAdd.newsConfigHead }}
                                </h5>
                              </v-card-text>

                              <v-card-text class="text--primary">
                                <h6 v-html="formAdd.newConfigDetail"></h6>
                              </v-card-text>
                              <!--
                <a :href="data.newsConfigLink">{{ data.newsConfigLink }}</a> -->

                              <v-col class="text-center">
                                <v-btn color="#C62929" dark>
                                  กลับหน้าเมนูข่าว
                                </v-btn>
                              </v-col>
                              <!-- </v-sheet> -->
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-card>
                    </v-col>
                    <v-col cols="8">
                      <v-form
                        ref="form_add"
                        v-model="valid_add"
                        lazy-validation
                      >
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="หัวข้อข่าว*"
                              v-model="formAdd.newsConfigTopic"
                              :rules="nameRules"
                              outlined
                              dense
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="หัวข้อข่าวรอง*"
                              v-model="formAdd.newsConfigHead"
                              :rules="nameRules"
                              outlined
                              dense
                              required
                            ></v-text-field>
                          </v-col>
                          <!-- <v-col cols="12">
                            <v-file-input
                              v-model="files"
                              show-size
                              accept="image/png, image/jpeg"
                              @change="fileupload"
                              placeholder="รูปปกข่าว (ไม่เกิน 5 MB)"
                              :rules="imageRules"
                              outlined
                              dense
                              required
                            ></v-file-input>
                          </v-col> -->

                          <v-file-input
                            v-model="files"
                            show-size
                            accept="image/*,.pdf"
                            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                            @change="fileupload()"
                            :rules="imageRules"
                            outlined
                            dense
                            required
                          ></v-file-input>
                          <v-file-input
                            v-model="files2"
                            show-size
                            accept="image/*,.pdf"
                            @change="fileupload2()"
                            :rules="imageRules"
                            outlined
                            dense
                            placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                            required
                          ></v-file-input>

                          <v-col cols="12">
                            <v-text-field
                              label="ลิ้งค์"
                              v-model="formAdd.newsConfigLink"
                              outlined
                              dense
                              required
                            ></v-text-field>
                          </v-col>
                          <!-- <v-col cols="12">
                      <vue-editor
                        v-model="formAdd.newConfigDetail"
                      ></vue-editor>
                    </v-col> -->

                          <v-col cols="12">
                            <VueEditor
                              v-model="formAdd.newConfigDetail"
                              :editorOptions="editorOptions"
                            />
                          </v-col>
                          <v-col cols="4">
                            <v-menu
                              ref="menu"
                              class="mx-1"
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="auto"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formAdd.newConfigStarttime"
                                  label="ตั้งแต่วันที่แสดงข่าว"
                                  persistent-hint
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="formAdd.newConfigStarttime"
                                no-title
                                locale="th-th"
                                :min="dateMin"
                                @input="menu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="formAdd.newsConfigType"
                              :items="statusType"
                              :rules="nameRules"
                              label="ประเภทข่าว"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="formAdd.newsConfigStatus"
                              :items="statusUse"
                              label="สถานะใช้งาน"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card :loading="loading">
              <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="(dialogAdd = false), clearData()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  v-if="formAdd.newsConfigTopic"
                  :disabled="!valid_add"
                  elevation="2"
                  x-large
                  color="success"
                  text
                  @click="addData(formAdd)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->
          <!-- ADD -->
          <v-dialog v-model="dialogAddVDO" persistent max-width="90%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มวีดีโอข่าว</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-form
                        ref="form_add"
                        v-model="valid_add"
                        lazy-validation
                      >
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              label="หัวข้อข่าว*"
                              v-model="formAdd.newsConfigTopic"
                              :rules="nameRules"
                              outlined
                              dense
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="หัวข้อข่าวรอง*"
                              v-model="formAdd.newsConfigHead"
                              :rules="nameRules"
                              outlined
                              dense
                              required
                            ></v-text-field>
                          </v-col>

                          <v-file-input
                            v-model="files"
                            show-size
                            accept="image/*,.pdf"
                            placeholder="รูปปกข่าว  (ไม่เกิน 5 MB)"
                            @change="fileupload()"
                            :rules="imageRules"
                            outlined
                            dense
                            required
                          ></v-file-input>

                          <v-file-input
                            v-model="filesvdo"
                            show-size
                            accept="image/*, .mp4"
                            placeholder="วีดีโอ (ไม่เกิน 50 MB)"
                            @change="fileuploadVDO()"
                            :rules="VDORules"
                            outlined
                            dense
                            required
                          ></v-file-input>
                          <v-file-input
                            v-model="files2"
                            show-size
                            accept="image/*,.pdf"
                            @change="fileupload2()"
                            :rules="imageRules"
                            outlined
                            dense
                            placeholder="รูปเพิ่มเติม (ไม่เกิน 5 MB)"
                            required
                          ></v-file-input>

                          <v-col cols="12">
                            <VueEditor
                              v-model="formAdd.newConfigDetail"
                              :editorOptions="editorOptions"
                            />
                          </v-col>
                          <v-col cols="4">
                            <v-menu
                              ref="menu"
                              class="mx-1"
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="auto"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formAdd.newConfigStarttime"
                                  label="ตั้งแต่วันที่แสดงข่าว"
                                  persistent-hint
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="formAdd.newConfigStarttime"
                                no-title
                                locale="th-th"
                                :min="dateMin"
                                @input="menu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="formAdd.newsConfigType"
                              :items="statusType"
                              :rules="nameRules"
                              label="ประเภทข่าว"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="formAdd.newsConfigStatus"
                              :items="statusUse"
                              label="สถานะใช้งาน"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="(dialogAddVDO = false), clearData()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  v-if="formAdd.newsConfigTopic"
                  :disabled="!valid_add"
                  elevation="2"
                  x-large
                  color="success"
                  text
                  @click="addData(formAdd)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- dialogView -->
          <v-dialog v-model="dialogView" persistent max-width="80%">
            <v-card>
              <v-card-text>
                <v-container>
                  <br />
                  <v-row>
                    <h5>หัวข้อข่าว:</h5>
                    <h5 class="purple--text">
                      {{ dataItemCheck.newsConfigTopic }}
                    </h5> </v-row
                  ><br />
                  <v-row>
                    <h5>หัวข้อข่าวรอง:</h5>
                    <h6 class="indigo--text">
                      {{ dataItemCheck.newsConfigHead }}
                    </h6>
                  </v-row>
                  <!-- data table -->
                  <v-col cols="12">
                    <v-card elevation="7" v-if="dataReady">
                      <v-card-title>
                        <v-text-field
                          v-model="searchAll2"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-card-text>
                        <v-data-table
                          :headers="columnsCheck"
                          :items="dataItemCheck"
                          :search="searchAll2"
                          :items-per-page="10"
                        >
                          <template v-slot:[`item.CREATE_DATE`]="{ item }">
                            {{ item.CREATE_DATE }}
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <!-- end data table -->
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogView = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end dialogView -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form
                    ref="form_update"
                    v-model="valid_update"
                    lazy-validation
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          label="หัวข้อข่าว*"
                          v-model="formUpdate.newsConfigTopic"
                          :rules="nameRules"
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="หัวข้อข่าวรอง*"
                          v-model="formUpdate.newsConfigHead"
                          :rules="nameRules"
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <center>
                          <v-img
                            :lazy-src="formUpdate.newsConfigFile"
                            max-height="auto"
                            max-width="1000"
                            :src="formUpdate.newsConfigFile"
                          ></v-img>
                        </center>

                        <br />
                        <v-file-input
                          v-model="filesEdit"
                          show-size
                          accept="image/png, image/jpeg"
                          @change="fileEditUpload"
                          placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                          :rules="imageRules"
                          outlined
                          dense
                          required
                        ></v-file-input>
                      </v-col>

                      <v-col cols="12" class="text-center">
                        <center>
                          <v-img
                            :lazy-src="formUpdate.newsConfigFileImg"
                            max-height="auto"
                            max-width="1000"
                            :src="formUpdate.newsConfigFileImg"
                          ></v-img>
                        </center>

                        <br />
                        <v-file-input
                          v-model="filesEdit2"
                          show-size
                          accept="image/png, image/jpeg"
                          @change="fileEditUpload2"
                          placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                          :rules="imageRules"
                          outlined
                          dense
                          required
                        ></v-file-input>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          label="ลิ้งค์"
                          v-model="formUpdate.newsConfigLink"
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <VueEditor
                          v-model="formUpdate.newConfigDetail"
                          :editorOptions="editorOptions"
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-menu
                          ref="menu2"
                          class="mx-1"
                          v-model="menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="auto"
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdate.newConfigStarttime"
                              label="ตั้งแต่วันที่แสดงข่าว"
                              persistent-hint
                              :rules="nameRules"
                              prepend-icon="mdi-calendar"
                              clearable
                              clear-icon="mdi-close-circle"
                              outlined
                              dense
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="formUpdate.newConfigStarttime"
                            no-title
                            locale="th-th"
                            :min="dateMin"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="formUpdate.newsConfigType"
                          :items="statusType"
                          label="ประเภทข่าว"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="formUpdate.newsConfigStatus"
                          :items="statusUse"
                          label="สถานะใช้งาน"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  text
                  @click="dialogEdit = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  :disabled="!valid_update"
                  @click="editData(formUpdate)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="หัวข้อข่าว*"
                        v-model="formUpdate.newsConfigTopic"
                        :rules="nameRules"
                        dens
                        readonly
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  text
                  @click="deleteData(formUpdate)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ item.CREATE_DATE }}
                  </template>
                  <template v-slot:[`item.action_1`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogView = true), getDataNewsCheck(item)"
                    >
                      <v-icon dark> mdi-account-check </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.action_2`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogEdit = true), getDataById(item)"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>

                    <v-btn
                      color="red"
                      dark
                      fab
                      small
                      @click.stop="(dialogDelete = true), getDataById(item)"
                    >
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.action_3`]="{ item }">
                    <v-btn
                      color="green"
                      dark
                      fab
                      small
                      @click.stop="setUpSendApprove(item)"
                    >
                      <v-icon> mdi-send </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import { VueEditor } from 'vue2-editor'
import moment from 'moment' // แปลง date

import { VueEditor, Quill } from 'vue2-editor'
import Emoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'

Quill.register(
  {
    'formats/emoji': Emoji.EmojiBlot,
    'modules/short_name_emoji': Emoji.ShortNameEmoji,
    'modules/toolbar_emoji': Emoji.ToolbarEmoji,
    'modules/textarea_emoji': Emoji.TextAreaEmoji
  },
  true
)

const editorOptions = {
  modules: {
    'emoji-toolbar': true,
    'emoji-shortname': true,
    toolbar: {
      container: [
        [{ size: ['small', false, 'large'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        ['image'],
        [{ font: [] }],
        [{ align: [] }],
        ['emoji']
      ]
    },
    short_name_emoji: true,
    toolbar_emoji: true
  }
}

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    VueEditor,
    readXlsxFile
  },
  computed: { editorOptions: () => editorOptions },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      html: '',
      PK: '',
      path: '/news_config/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการข้อมูล News',
          disabled: true,
          href: '/System/News'
        }
      ],
      // End Menu Config
      dataReady: true,
      date: new Date().toISOString().substr(0, 10),
      dateMax: moment().endOf('year').format('YYYY-MM-DD'),
      dateMin: moment().subtract(3, 'd').format('YYYY-MM-DD'),
      dateNow: moment().format('YYYY-MM-DD'),
      menu: false,
      menu2: false,
      code: 'NEW', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogAddVDO: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      valid_add: true,
      valid_update: true,
      formAdd: {
        newsConfigTopic: '',
        newsConfigHead: '',
        newsConfigFile: '',
        newsConfigFileImg: '',
        newsConfigStatus: 'OFF',
        newConfigStarttime: '',
        newsConfigType: '',
        newsConfigLink: ''
      },
      files: null,
      files2: null,
      filesvdo: null,
      filesEdit: null,
      filesEdit2: null,
      loading: false,
      formUpdate: [],
      formData: [],
      nameRules: [(v) => !!v || 'กรุณา กรอกข้อมูล'],
      imageRules: [
        (value) =>
          !value || value.size < 5000000 || 'size should be less than 5 MB!'
      ],
      VDORules: [
        (value) =>
          !value || value.size < 65014286 || 'size should be less than 5 MB!'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รหัสข่าว', value: 'newsConfigId' },
        { text: 'หัวข้อข่าว', value: 'newsConfigTopic' },
        { text: 'หัวข้อข่าวรอง', value: 'newsConfigHead' },
        { text: 'ประเภทข่าว', value: 'newsConfigType' },
        { text: 'สถานะข่าว', value: 'newsConfigStatus' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่เปิดข่าว', value: 'newConfigStarttime' },
        {
          text: 'รายชื่อคนที่อ่าน',
          value: 'action_1',
          sortable: false,
          align: 'center'
        },
        { text: 'Action', value: 'action_2', sortable: false, align: 'center' },
        {
          text: 'Broadcast',
          value: 'action_3',
          sortable: false,
          align: 'center'
        }
      ],
      dataItem: [],
      columnsCheck: [
        { text: 'รหัสข่าว', value: 'newsConfigId' },
        { text: 'empCode', value: 'empCode' },
        { text: 'empFull_NameTH', value: 'empFull_NameTH' },
        { text: 'วันที่อ่าน', value: 'CREATE_DATE' }
      ],
      dataItemCheck: [],
      // End Data Table Config
      // End Export Config
      statusUse: ['ON', 'OFF'],
      statusType: ['VgroupNews', 'ข่าวทั่วไป', 'สาระน่ารู้', 'กิจกรรม']
    }
  },
  async mounted () {
    this.getGetToken()
    // this.dataReady = false
    // Get Data
    this.getData()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getData () {
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/news_config/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    getDataById (item) {
      console.log('get date edit', item)
      this.formUpdate = item
    },
    getDataNewsCheck (item) {
      console.log('get date edit', item)
      this.formData = item
      this.getDataCheck(item)
    },
    async getDataCheck (dt) {
      console.log('DT', dt.newsConfigId)
      this.dataItemCheck = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/news_check/getNewsConfigId?newsConfigId=' +
            dt.newsConfigId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            this.dataItemCheck = response.data
            this.dataItemCheck.newsConfigTopic =
              response.data[0].newsConfigTopic
            this.dataItemCheck.newsConfigHead = response.data[0].newsConfigHead
            console.log(
              'this.dataItemCheck',
              this.dataItemCheck.newsConfigTopic
            )
            console.log(
              'this.dataItemCheck',
              this.dataItemCheck.newsConfigHead
            )
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async addData (dt) {
      console.log('dt', dt)
      dt.CREATE_USER = this.$session.getAll().data.userName
      dt.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.loading = true
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/news_config/add",
              dt,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              this.loading = false
              this.dialogAdd = false

              // Load Data
              await this.getData()
              this.clearData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData (dt) {
      let ds = {
        newsConfigTopic: dt.newsConfigTopic,
        newsConfigHead: dt.newsConfigHead,
        newsConfigStatus: dt.newsConfigStatus,
        newsConfigFile: dt.newsConfigFile,
        newsConfigFileImg: dt.newsConfigFileImg,
        newsConfigLink: dt.newsConfigLink,
        newConfigDetail: dt.newConfigDetail,
        newConfigStarttime: dt.newConfigStarttime,
        newsConfigType: dt.newsConfigType,
        LAST_USER: this.$session.getAll().data.userName
      }
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/news_config/edit/" + dt.newsConfigId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dataReady = true
              this.dialogEdit = false

              // Load Data
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData (dt) {
      let ds = {
        LAST_USER: this.$session.getAll().data.userName
      }
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/news_config/delete/" + dt.newsConfigId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dataReady = true
              this.dialogDelete = false
              // Load Data
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.files)
      if (_this.files.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'news'
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.formAdd.newsConfigFile =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files = null
      }
    },
    async fileuploadVDO () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.files)
      if (_this.files.size < 20000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'news'
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.formAdd.newsConfigVdo =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files = null
      }
    },
    async fileupload2 () {
      const _this = this
      let params = new FormData()
      if (_this.files2.size < 5000000) {
        params.append('file', _this.files2)
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'news'
              }
            })
            .then(function (response) {
              _this.formAdd.newsConfigFileImg =
                _this.DNS_IP_UPLOAD + '/' + response.data
            }) // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.newsConfigFileImg = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files2 = null
        }

        console.log('this.files2', _this.formAdd.newsConfigFileImg)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files2 = null
      }
    },
    async fileEditUpload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.filesEdit)
      if (_this.filesEdit.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'news'
              }
            })
            .then(function (response) {
              console.log('filesEdit', response.data)
              _this.formUpdate.newsConfigFile =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.filesEdit', _this.filesEdit)
        console.log('this.filesEdit', _this.filesEdit.size)
      }
    },
    async fileEditUpload2 () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.filesEdit2)
      if (_this.filesEdit2.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'news'
              }
            })
            .then(function (response) {
              console.log('filesEdit2', response.data)
              _this.formUpdate.newsConfigFileImg =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.filesEdit2', _this.filesEdit2)
        console.log('this.filesEdit2', _this.filesEdit2.size)
      }
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        console.log('Key', key)
        console.log('Value', this.formAdd)

        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
      this.files = null
      this.files2 = null

      // eslint-disable-next-line no-redeclare
      for (var key in this.search) {
        console.log('Key', key)
        console.log('Value', this.search)

        if (this.search[key]) {
          this.search[key] = ''
        }
      }
    },
    async setUpSendApprove (dt) {
      console.log('dt', dt)
      this.$swal({
        title: 'ต้องการ ประชาสัมพันธ์ ข่าวนี้ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#09b304',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          var payload = [
            {
              type: 'flex',
              altText: 'อัพเดทข่าวใหม่',
              contents: {
                type: 'bubble',
                header: {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: dt.newsConfigType,
                      color: '#FFFFFF',
                      weight: 'bold'
                    }
                  ]
                },
                hero: {
                  type: 'image',
                  url: dt.newsConfigFile,
                  size: 'full',
                  margin: 'md',
                  aspectRatio: '40:23',
                  offsetTop: 'xs'
                },
                body: {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: dt.newsConfigTopic,
                      size: 'md',
                      weight: 'bold'
                    },
                    {
                      type: 'text',
                      text: dt.newsConfigHead,
                      wrap: true,
                      color: '#311B92',
                      size: 'sm',
                      flex: 5
                    },
                    {
                      type: 'separator',
                      margin: 'xl'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'button',
                          action: {
                            type: 'uri',
                            label: 'อ่านเพิ่มเติม',
                            uri:
                              'https://liff.line.me/1654154168-xdq6wM84?action=read&auto=' +
                              Math.floor(Math.random() * 999999999999)
                          }
                        },
                        {
                          type: 'button',
                          action: {
                            type: 'uri',
                            label: 'ข่าวทั้งหมด',
                            uri:
                              'https://liff.line.me/1654154168-xdq6wM84?action=all&auto=' +
                              Math.floor(Math.random() * 999999999999)
                          }
                        }
                      ]
                    }
                  ]
                },
                styles: {
                  header: {
                    backgroundColor: '#C62929'
                  }
                }
              }
            }
          ]
          console.log(payload)
          await this.sendLinePush(payload)
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function broadcast : ', error)
        })
    },
    async sendLinePush (payload) {
      const msgPayload = {
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(this.DNS_IP + '/line/broadcast', dt, {
        headers: {
          'Application-Key': localStorage.getItem('ApplicationKey')
        }
      })
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/System/News.vue